import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule} from '@angular/material/button';
import { MqIfDirectiveModule } from '../../_directives/mqif.directive';

import { ClientHeaderRoutingModule } from './client-header-routing.module';
import { ClientHeaderComponent } from './client-header.component';

@NgModule({
    imports: [
        CommonModule,
        ClientHeaderRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        MatCardModule,
        MatIconModule,
        MatTableModule,
        MatCheckboxModule,
        MatPaginatorModule,
        MatSelectModule,
        MatChipsModule,
        MatInputModule,
        MatButtonModule,
        MqIfDirectiveModule,
    ],
    declarations: [
        ClientHeaderComponent
    ],
    exports: [
        ClientHeaderComponent
    ],
})
export class ClientHeaderModule { }
